import { Address, ShippingAddress } from 'types/api/intent';

export function isFullAddress(address: Address | undefined) {
  return Boolean(
    address?.city &&
      address.city.length <= 50 &&
      address.line1 &&
      address.postalCode &&
      address.postalCode.length <= 16
  );
}

export function isAddressValidated(address: ShippingAddress | undefined) {
  return Boolean(
    (address?.city ? address.city.length <= 50 : true) &&
      (address?.line1 ? address.line1.length <= 75 : true) &&
      (address?.line2 ? address.line2.length <= 75 : true) &&
      (address?.line3 ? address.line3.length <= 75 : true) &&
      (address?.postalCode ? address.postalCode.length <= 50 : true) &&
      (address?.countryCode ? address.countryCode.length <= 50 : true) &&
      (address?.state ? address.state.length <= 50 : true)
  );
}
